const LOTTIE_CDN =
  "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js";

let loadPromise = null;

/**
 * Loads lottie-web from CDN once (no npm dependency).
 * @returns {Promise<typeof import('lottie-web')>}
 */
export const loadLottieWebFromCdn = () => {
  if (typeof window !== "undefined" && window.lottie) {
    return Promise.resolve(window.lottie);
  }

  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-lottie-web-cdn="true"]');
      if (existing) {
        existing.addEventListener("load", () => resolve(window.lottie));
        existing.addEventListener("error", reject);
        return;
      }

      const script = document.createElement("script");
      script.src = LOTTIE_CDN;
      script.async = true;
      script.dataset.lottieWebCdn = "true";
      script.onload = () => {
        if (window.lottie) {
          resolve(window.lottie);
        } else {
          reject(new Error("lottie-web failed to load"));
        }
      };
      script.onerror = () => reject(new Error("lottie-web script failed to load"));
      document.head.appendChild(script);
    });
  }

  return loadPromise;
};
